import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const CavityFree = ({ color }) => (
  <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.334 8.194c1.154 2.732-.304 5.764-3.03 6.766-.424.155-.832-.164-.832-.602v-3.405c0-1.382-2.096-1.382-2.096 0v3.427a.62.62 0 0 1-.865.567c-2.732-1.026-4.134-4.061-2.996-6.753-2.71-1.23-3.385-4.816-1.261-6.94a4.293 4.293 0 0 1 6.17.11 4.293 4.293 0 0 1 6.17-.11c2.125 2.124 1.448 5.71-1.26 6.94zm-1.382 0a.62.62 0 0 1 .362-.947c2.283-.576 3.077-3.446 1.406-5.117-1.402-1.402-3.74-1.107-4.765.566a.618.618 0 0 1-1.057.007C5.878 1.029 3.538.723 2.13 2.13.502 3.758 1.35 6.872 3.394 7.209c.336.055.833.446.52.96-1.102 1.806-.508 4.082 1.226 5.214v-2.43c0-3.016 4.57-3.016 4.57 0v2.43c1.722-1.125 2.324-3.387 1.242-5.19z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

CavityFree.defaultProps = {
  color: colors.blue,
};

CavityFree.propTypes = {
  color: PropTypes.string,
};

export default CavityFree;
